import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

import { OVERLAY_Z_INDEX } from '../constants/z-index';

const createOverlay = (zIndex: number) => {
  const overlayElement = document.createElement('div');
  overlayElement.setAttribute('data-testid', 'body-overlay');
  overlayElement.style.position = 'fixed';
  overlayElement.style.top = '0';
  overlayElement.style.left = '0';
  overlayElement.style.right = '0';
  overlayElement.style.bottom = '0';
  overlayElement.style.zIndex = zIndex.toString();
  overlayElement.style.background = 'rgba(0, 0, 0, 0.6)';

  return overlayElement;
};

export const useBodyOverlay = (
  overlayZIndex = OVERLAY_Z_INDEX,
  parentRef?: RefObject<HTMLElement>
) => {
  const [isBodyOverlayVisible, setIsBodyOverlayVisible] = useState(false);

  useEffect(() => {
    const parentNode = parentRef?.current ?? document.body;
    let overlayElement: HTMLDivElement;

    if (isBodyOverlayVisible) {
      overlayElement = createOverlay(overlayZIndex);
      parentNode.prepend(overlayElement);
    }

    return () => {
      if (overlayElement) {
        parentNode.removeChild(overlayElement);
      }
    };
  }, [isBodyOverlayVisible, overlayZIndex, parentRef]);

  return { isBodyOverlayVisible, setIsBodyOverlayVisible };
};
